import type { EventFormData, FormSettings } from './types';

const DEFAULT_FORM_SETTINGS: FormSettings = {
  hasAttendanceQuestion: false,
  phoneFields: 'optional',
  addressFields: 'hidden',
};

export const parseFormSettings = (settings: EventFormData['settings']): FormSettings => {
  if (!settings) {
    return DEFAULT_FORM_SETTINGS;
  }

  return {
    hasAttendanceQuestion: settings.attendanceQuestionRequired ?? DEFAULT_FORM_SETTINGS['hasAttendanceQuestion'],
    phoneFields: settings.phoneFields ?? DEFAULT_FORM_SETTINGS['phoneFields'],
    addressFields: settings.addressFields ?? DEFAULT_FORM_SETTINGS['addressFields'],
  };
};
